import React from 'react';

type CheckboxProps = {
  id?: string;
  value: string;
  label: string;
  name?: string;
  checked?: boolean;
  count?: number;
  onChange: (bool: boolean) => void;
};

export const Checkbox = ({
  id,
  value,
  name,
  label,
  checked,
  onChange,
  count = 0
}: CheckboxProps) => (
  <div className="checkbox">
    <div className="checkbox__wrapper">
      <input
        id={id}
        name={name}
        type="checkbox"
        value={value}
        className="hide-visually"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />

      <span className="checkbox__custom-checkbox">
        <svg className="icon icon--Checkmark" viewBox="0 0 240 240">
          <path d="m188.9 49.91 22.2 20.18-109.665 120.631-71.038-59.198 19.206-23.046 48.961 40.801z" />
        </svg>
      </span>

      <label htmlFor={id} className="typo-form-value font-bold">
        {label}

        {count > 0 && (
          <span className="checkbox__count font-bold">{count}</span>
        )}
      </label>
    </div>
  </div>
);
